import React, { useRef, useEffect } from 'react';
import ReactHlsPlayer from 'react-hls-player';

type VideoPlayerProps = {
  availableHeight: number;
  availableWidth: number;
  streamUrl: string;
  isPlaying?: boolean;
  onPlayPause?: (playing: boolean) => void;
};

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  availableHeight,
  streamUrl,
  availableWidth,
  isPlaying = false,
  onPlayPause
}) => {
  const playerRef = useRef<HTMLVideoElement>(null);

  const aspectRatio = 16 / 9;
  const heightBasedWidth = availableHeight * aspectRatio;
  const widthBasedHeight = availableWidth / aspectRatio;

  let finalWidth: number;
  let finalHeight: number;

  if (heightBasedWidth <= availableWidth) {
    finalHeight = availableHeight;
    finalWidth = heightBasedWidth;
  } else {
    finalWidth = availableWidth;
    finalHeight = widthBasedHeight;
  }

  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.style.width = `${finalWidth}px`;
      playerRef.current.style.height = `${finalHeight}px`;
      playerRef.current.style.objectFit = 'contain';
      playerRef.current.controls = true;
    }
  }, [finalWidth, finalHeight]);

  useEffect(() => {
    if (playerRef.current) {
      if (isPlaying) {
        playerRef.current.play().catch(e => console.error("Play failed:", e));
      } else {
        playerRef.current.pause();
      }
    }
  }, [isPlaying]);

  const handlePlayPause = () => {
    if (playerRef.current && onPlayPause) {
      onPlayPause(!playerRef.current.paused);
    }
  };

  return (
    <div
      className="flex items-center justify-center text-white"
      style={{
        width: '100%',
        height: availableHeight,
        position: 'relative',
      }}
    >
      <ReactHlsPlayer
        className="react-player"
        autoPlay={isPlaying}
        playerRef={playerRef}
        src={streamUrl}
        controls={true}
        muted
        hlsConfig={{
          lowLatencyMode: true,
          backBufferLength: 90,
          maxLiveSyncPlaybackRate: 1.5,
          liveSyncDuration: 3,
          liveMaxLatencyDuration: 5,
          maxBufferLength: 30,
          enableWorker: true,
        }}
        onClick={handlePlayPause}
        style={{
          width: `${finalWidth}px`,
          height: `${finalHeight}px`,
          background: 'black',
          objectFit: 'contain',
        }}
      />
    </div>
  );
};

export default VideoPlayer;